import { pipe } from 'fp-ts/function'
import { decodeJson, get } from 'lib/request'

import { TAppLanguages, TLanguages } from './languages.codecs'

export const getLanguagesList = async () => {
  return pipe(await get('api/languages', {}), decodeJson(TLanguages))
}

export const getAppLanguages = async () => {
  return pipe(await get('api/app/languages', {}), decodeJson(TAppLanguages))
}
